
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : `0${n}`;
}

export default {
  // 格式化日期
  formatDate(time) {
    const date = new Date(time);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return [year, month, day].map(formatNumber).join('-');
  },
};



// WEBPACK FOOTER //
// ./src/services/format-date-service.js